import debug from 'debug'

const log = debug('xpedeo-core:nfc')
debug.enable(process.env.VUE_APP_DEBUG)

// export plugin
export default {
  __isEnabled: false,
  __$xp: null,
  __router: null,
  __isListenersAdded: false,
  get isEnabled () {
    return this.__isEnabled
  },
  enable () {
    log('nfc.enable()')
    if (this.__$xp.device.platform === 'browser') {
      log('nfc.enable(): nfc is not available in browser')
      return
    }
    window.nfc.enabled(success => {
      log(`Nfc is enabled, ${success}`)
      if (this.__$xp.device.platform === 'android') {
        if (this.__isListenersAdded) {
          log('listeners are already added')
          this.__isEnabled = true
          return
        }
        window.nfc.addNdefListener(this.onNfcNdef.bind(this), () => { this.__isEnabled = true }, () => { log('Error in nfc.addNdefListener') })
        this.__isListenersAdded = true
      } else this.__isEnabled = true
    }, failure => {
      log(`Failed to enable Nfc, ${failure}`)
    })
  },
  disable () {
    log('nfc.disable()')
    if (this.__$xp.device.platform === 'browser') {
      log('nfc.disable(): nfc is not available in browser')
    } else if (this.__$xp.device.platform === 'android') {
      this.__isEnabled = false
    } else if (this.__$xp.device.platform === 'ios') {
      this.__isEnabled = false
      window.nfc.cancelScan().then(
        success => {
          log(`Cancelled NFC session ${success}`)
          this.__isEnabled = false
        },
        err => {
          log(`Error cancelling session ${err}`)
          this.__isEnabled = undefined
        }
      )
    }
    /**
     * see https://github.com/chariotsolutions/phonegap-nfc#nfcremovendeflistener
     * Removing listeners is not recommended. Instead, consider that your callback can ignore messages you no longer need.
     */
    // window.nfc.removeNdefListener(this.onNfcNdef.bind(this), () => { this.__isEnabled = false }, () => { log('Error in nfc.removeNdefListener') })
    // if (this.__$xp.device.platform === 'ios') {
    //   window.nfc.invalidateSession(() => {}, () => { log('Error in nfc.invalidateSession') }) // eslint-disable-line
    // }
  },
  onNfcNdef (nfcEvent) {
    if (!this.isEnabled) {
      return
    }
    const tag = nfcEvent.tag
    log('onNfcNdef: ' + JSON.stringify(tag), this.__$xp)
    if (tag.ndefMessage && tag.ndefMessage.length) {
      for (const i in tag.ndefMessage) {
        const message = tag.ndefMessage[i]
        const payload = window.nfc.bytesToString(message.payload)
        log('onNfcNdef: payload = ' + payload)
        const match = payload.match(/\/#\/nfc\/(.+)$/)
        if (match) {
          const code = match[1]
          let pageId = window.localStorage.getItem('nfcPageId') || this.__$xp.settings.mergedSettings.nfcPageId
          if (!pageId) {
            pageId = this.__$xp.settings.getValue('content.startPageID')
          }
          const path = `/page/${pageId}?nfcCode=${code}`
          log(`router.push: path=${path}`)
          this.__router.push({ path: path })
          break
        }
      }
    }
  },
  scanNdefIos () {
    if (this.__$xp.device.platform === 'ios' && this.isEnabled) {
      window.nfc.scanNdef().then(
        iTag => {
          log(`in scanNdefIos ${iTag}`)
          this.onNfcNdef({ tag: iTag })
          return true
        },
        err => {
          log('Error scanning tag on iOS', err)
          return false
        }
      )
    }
  },
  install (Vue, opts, $xp) {
    log('Installing NFC Plugin')
    const router = opts.router
    if ($xp.nfcInstalled) { return }
    if (!opts.router) {
      throw new Error('NFC plugin needs router to initialize')
    }
    this.__$xp = $xp
    this.__router = router
    this.__router.addRoutes([
      {
        path: '/nfc/:nfcCode',
        redirect: to => {
          let pageId = window.localStorage.getItem('nfcPageId') || $xp.settings.getValue('content.nfcPageId')
          if (!pageId) {
            pageId = $xp.settings.getValue('content.startPageID')
          }
          return { path: `/${$xp.polyglot.urlPath}page/${pageId}`, query: { nfcCode: to.params.nfcCode } }
        }
      }
    ])
    $xp.nfcInstalled = true
    Vue.util.defineReactive($xp, 'nfc', this)
  }
}
